/**
 * Shared types and configurations for product components
 */

/**
 * Product status tags indicating what the startup needs
 */
export type StatusTag =
  | "investment"
  | "feedback"
  | "partnerships"
  | "mentors"
  | "hiring";

/**
 * Status tag visual configuration with semantic colors
 */
export const STATUS_TAG_CONFIG: Record<
  StatusTag,
  { label: string; icon: string; color: string; bgColor: string; dotColor: string }
> = {
  investment: {
    label: "Ищет инвестиции",
    icon: "💰",
    color: "text-[color:var(--status-investment)]",
    bgColor: "bg-[color:var(--status-investment)]/10",
    dotColor: "bg-[color:var(--status-investment)]",
  },
  feedback: {
    label: "Нужен фидбек",
    icon: "🔥",
    color: "text-[color:var(--status-feedback)]",
    bgColor: "bg-[color:var(--status-feedback)]/10",
    dotColor: "bg-[color:var(--status-feedback)]",
  },
  partnerships: {
    label: "Ищет партнёров",
    icon: "🤝",
    color: "text-[color:var(--status-partnership)]",
    bgColor: "bg-[color:var(--status-partnership)]/10",
    dotColor: "bg-[color:var(--status-partnership)]",
  },
  mentors: {
    label: "Ищет менторов",
    icon: "🎓",
    color: "text-[color:var(--status-mentors)]",
    bgColor: "bg-[color:var(--status-mentors)]/10",
    dotColor: "bg-[color:var(--status-mentors)]",
  },
  hiring: {
    label: "Нанимает",
    icon: "👨‍💻",
    color: "text-[color:var(--status-hiring)]",
    bgColor: "bg-[color:var(--status-hiring)]/10",
    dotColor: "bg-[color:var(--status-hiring)]",
  },
};
